import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, clearToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fnFilter, setFnFilter] = useState("Both");

  // Session restore: the httpOnly cookie (if present) authenticates this call.
  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data.function_scope !== "Both") setFnFilter(r.data.function_scope);
      })
      .catch(() => {
        clearToken();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, remember = true) => {
    const r = await api.post("/auth/login", { email, password, remember });
    setToken(r.data.token); // in-memory only; persistence is the httpOnly cookie
    setUser(r.data.user);
    if (r.data.user.function_scope !== "Both") setFnFilter(r.data.user.function_scope);
    else setFnFilter("Both");
    return r.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout request failed (clearing local session anyway):", e);
    }
    clearToken();
    setUser(null);
    window.location.href = "/login";
  };

  const value = useMemo(
    () => ({ user, login, logout, loading, fnFilter, setFnFilter }),
    [user, loading, fnFilter]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
